import { h } from "preact";
import { route, RouterProps } from "preact-router";
import { useData } from "../services/data";
import { getCategoryUrl } from "../services/navigation";
import { useEffect } from "preact/hooks";

export function DefaultPage(props: RouterProps): h.JSX.Element {
    const data = useData();
    useEffect(() => {
        if (data.ready) {
            //document.location.replace(getCategoryUrl(data.categories[0]));
            route(getCategoryUrl(data.categories[0]), true)
        }
    }, [data]);
    return (
        <div />
    )
}
